export default {"src":"/_next/static/media/ads.02184952.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};